import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateInputComponent } from 'components/input/date-input/date-input.component';
import { CredentialType } from 'enums/CredentialType';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { InvoicingService } from 'services/invoicing.service';
import { CredentialRequired } from 'services/credential.service';
import { FormValidationService } from 'services/form-validation.service';
import { NavigationService } from 'services/navigation.service';

@CredentialRequired(CredentialType.EditInvoiceDueDate)
@Component({
	templateUrl: './edit-invoice-duedate.component.html',
	providers: [FormValidationService],
	imports: [Layout, FormsModule, DateInputComponent, TranslatePipe]
})
export class EditInvoiceDueDateComponent {
	@Input() dueDate!: Date;
	@Input() ledgerHeaderId!: string;

	constructor(
		private readonly invoicingService: InvoicingService,
		private readonly navigationService: NavigationService) { 
	}

	editDueDate() {
		this.invoicingService.editInvoiceDueDate(this.ledgerHeaderId, this.dueDate).then(response => {
			this.navigationService.closeView(this);
		});
	}
}
